import { Component } from "@angular/core";

@Component({
    selector: 'account-created',
    templateUrl: './account-created.component.html'
})
export class AccountCreated {
}